"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeChannelsClient = void 0;
const test_support_1 = require("../../../test-support");
const types_1 = require("../../../types");
const PageableFactory_1 = require("../../common/model/PageableFactory");
const IngestType_1 = require("../model/IngestType");
class FakeChannelsClient {
    constructor() {
        this.channels = [];
        this.updatedCategoryDescription = 'default description';
        this.contentCategories = [
            { key: 'key 1', label: 'label 1' },
            { key: 'key 2', label: 'label 2' },
        ];
    }
    create(request) {
        const id = request.name + Date.now();
        const fakeAgeRangeRequest = {
            min: 3,
            max: 7,
            label: '3-7',
            ids: ['early-years'],
        };
        this.channels.push({
            id,
            name: request.name,
            currency: request.currency,
            legalRestriction: request.legalRestrictions,
            distributionMethods: request.distributionMethods,
            contentCategories: request.contentCategories?.map((key) => ({
                key,
                label: `Label: ${key}`,
            })),
            description: request.description,
            notes: request.notes,
            language: { code: request.language, name: request.language },
            contentType: request.contentType,
            oneLineDescription: request.oneLineDescription,
            marketingInformation: request.marketingInformation,
            pedagogyInformation: {
                subjects: request.subjects,
                bestForTags: request.bestForTags,
                ageRanges: fakeAgeRangeRequest,
            },
            ingest: { type: IngestType_1.IngestType.MANUAL },
            educationLevels: request.educationLevels?.map((levelCode) => ({
                code: levelCode,
            })),
            links: { self: new types_1.Link({ href: `/v1/channels/${id}` }) },
        });
        return Promise.resolve();
    }
    insertFixture(channels) {
        channels.forEach((it) => {
            this.channels.push(test_support_1.ChannelFactory.sample(it));
        });
    }
    getContentCategories() {
        return Promise.resolve({ categories: this.contentCategories });
    }
    getAll(filterOptions) {
        let channels = this.channels;
        if (filterOptions?.ingestType) {
            channels = channels.filter((channel) => channel.ingest?.type &&
                filterOptions.ingestType.indexOf(channel.ingest.type) > -1);
        }
        if (filterOptions?.categories) {
            channels = channels.filter((channel) => {
                return (channel.taxonomy?.categories &&
                    channel.taxonomy?.categories.some((it) => filterOptions.categories?.includes(it.codeValue)));
            });
        }
        if (filterOptions?.education_levels) {
            channels = channels.filter((channel) => {
                return (channel.educationLevels &&
                    channel.educationLevels.some((it) => filterOptions.education_levels?.includes(it.code)));
            });
        }
        return Promise.resolve(PageableFactory_1.PageableFactory.sample(channels, {
            size: filterOptions?.size,
            number: filterOptions?.page,
        }));
    }
    get(id) {
        const retrievedContentPartner = this.channels.find((i) => i.id === id);
        if (retrievedContentPartner != undefined) {
            return Promise.resolve(retrievedContentPartner);
        }
        else {
            const error = {
                error: 'Content partner not found',
                message: `No content partner found for this id: ${123}`,
                path: `/v1/content-partner/${id}`,
                timestamp: new Date(),
                status: 404,
            };
            return Promise.reject(error);
        }
    }
    update(id, channelRequest) {
        const index = this.channels.findIndex((i) => i.id === id);
        if (index < 0) {
            return Promise.reject();
        }
        const { name, legalRestrictions, ageRanges, distributionMethods, currency, description, notes, language, contentCategories, contentType, oneLineDescription, marketingInformation, subjects, bestForTags, ingest, contractId, categories, requiresVideoLevelTagging, educationLevels, } = channelRequest;
        const originalChannel = this.channels[index];
        this.channels[index] = {
            ...originalChannel,
            name: name || originalChannel.name,
            legalRestriction: legalRestrictions || originalChannel.legalRestriction,
            pedagogyInformation: {
                ageRanges: {
                    ids: ageRanges || originalChannel.pedagogyInformation?.ageRanges.ids,
                },
                subjects: subjects || originalChannel.pedagogyInformation?.subjects || [],
                bestForTags: bestForTags || originalChannel.pedagogyInformation?.bestForTags || [],
            },
            distributionMethods: distributionMethods || originalChannel.distributionMethods,
            currency: currency || originalChannel.currency,
            description: description || originalChannel.description,
            notes: notes || originalChannel.notes,
            language: language
                ? { name: language, code: language }
                : originalChannel.language,
            taxonomy: {
                categories: !requiresVideoLevelTagging
                    ? this.hydrateCategories(categories)
                    : [],
                requiresVideoLevelTagging: requiresVideoLevelTagging ||
                    originalChannel.taxonomy?.requiresVideoLevelTagging,
            },
            contentCategories: contentCategories?.map((category) => ({
                key: category,
                label: category,
            })) || originalChannel.contentCategories,
            contentType: contentType || originalChannel.contentType,
            oneLineDescription: oneLineDescription || originalChannel.oneLineDescription,
            marketingInformation: marketingInformation || originalChannel.marketingInformation,
            ingest: ingest || originalChannel.ingest,
            contractId: contractId || originalChannel.contractId,
            educationLevels: educationLevels?.map((levelCode) => ({ code: levelCode })) ||
                originalChannel.educationLevels,
        };
        return Promise.resolve();
    }
    hydrateCategories(categories) {
        return (categories?.map((codeValue) => ({
            codeValue: codeValue,
            description: this.updatedCategoryDescription,
        })) || []);
    }
    clear() {
        this.channels = [];
        this.updatedCategoryDescription = 'default description';
    }
    async getSignedLink(filename) {
        const newFilename = filename.replace('.', '_') + '_signed_link';
        const signedLinkUrl = `http://www.server.com/${newFilename}`;
        return Promise.resolve(signedLinkUrl);
    }
    setCategoryDescription(description) {
        this.updatedCategoryDescription = description;
    }
}
exports.FakeChannelsClient = FakeChannelsClient;
//# sourceMappingURL=FakeChannelsClient.js.map